import * as React from "react";
import {Link} from "react-router-dom";

import "./customize-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Responsive}     from "@Common/ui-components/responsive";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {Breadcrumbs2} from "../../../../common/breadcrumbs2/breadcrumbs2";
import {Layout}       from "../../../../layout/layout";

export const CustomizeLayout = ({active=null, disabled=[], customizable, isKit, back=null, addressable, beforeNav=null, item=null, isApprovalAfterProof=false, next}) => cs(
    consumeContext("company"),
    consumeContext("routerHistory"),
    ({}, next) => Layout({
        className: "customize-layout-95r",
        active,
        children: next(),
    }),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
            tablet: 886,
        },
        next,
    }}/>],
    ["isFromApproval", (_, next) => next(parseUrlQuery(location.search)?.referrer === "approval-requests")],
    ["cartId", (_, next) => next(parseUrlQuery(location.search)?.id_cart)],
    ({company, responsive, isFromApproval, cartId, routerHistory}) => (
        <>
            <div className="header">
                {back && (
                    <Link
                        className="back"
                        to={back.link ? back.link + buildUrlQuery({
                            ...isFromApproval && active !== "product-options" && {
                                id_cart: cartId,
                                referrer: "approval-requests",
                            }
                        }) : "/"}
                        xd-qa-type="link"
                        xd-qa-name={back.label}
                        onClick={(e) => {
                            if (back.link?.includes('/next/')) {
                                window.location.href = back.link;
                                e.preventDefault();
                            }
                        }}
                    >
                        <i className="fa fa-chevron-left"/>
                        {back.label}
                    </Link>
                )}
                {Breadcrumbs2({
                    className: "center",
                    steps: [
                        {
                            label: (responsive.lt("mobile") ? "Product" : "Product Options"),
                            name: "product-options",
                            link: `/product-options/order/${item?.itemId}` + buildUrlQuery({
                                ...isFromApproval && {
                                    id_cart: cartId,
                                    referrer: "approval-requests"
                                }
                            }),
                        },
                        (company?.prefs?.xpressoKitOptionsActive && isKit) && {
                            label: responsive.lt("mobile") ? "Kit" : "Kit Options",
                            name: "kit-options",
                            link: `/kit-options/order/${item?.itemId}` + buildUrlQuery({
                                ...isFromApproval && {
                                    id_cart: cartId,
                                    referrer: "approval-requests"
                                }
                            }),
                        },
                        customizable && {
                            label: "Customization",
                            name: "customization",
                            link: item?.metaData?.ccReferenceURLs || company?.prefs?.allowBuild3 ? (
                                `/customize/order/${item?.itemId}` + buildUrlQuery({
                                    ...isFromApproval && {
                                        id_cart: cartId,
                                        referrer: "approval-requests"
                                    }
                                })
                            ) : (
                                `/next/start.php` + buildUrlQuery({
                                    action: "edit",
                                    id_order: `${item?.itemId}`,
                                    order_exists: "exists",
                                    procform: 1,
                                    redirect: "customize",
                                    ...isFromApproval && {
                                        approval: 1,
                                    },
                                })
                            ),
                        },
                        (!isApprovalAfterProof && addressable) && {
                            label: responsive.lt("mobile") ? "Distribution" : "Distribution Options",
                            name: "distribution-options",
                        },
                        !isApprovalAfterProof && {
                            label: "Checkout",
                            name: "checkout",
                        },
                    ]
                        .filter(v=>v)
                        .map((step) => ({
                            label: step.label,
                            active: active === step.name,
                            disabled: disabled.find((e) => step.name === e),
                            onSelect: async () => {
                                if (beforeNav && !(await beforeNav())) {
                                    return;
                                }
                                if (step.link.includes('/next/')) {
                                    window.location.href = step.link;
                                } else {
                                    routerHistory.push(step.link);
                                }
                            },
                        }))
                    ,
                })}
            </div>
            {item?.itemId && <span hidden xd-qa-type="label" xd-qa-name="Order ID">{item.itemId}</span>}
            {/* "tabIndex={999}" below added for AI/VDP/SuggComments Frame UI/UX. please do not remove */}
            <div className="main" tabIndex={999}>
                {next()}
            </div>
        </>
    ),
);
